import React, { useEffect } from "react";
import Infiry from "../../About/Infiry";
import Callin from "../../About/Callin";
import Servicebanner from "../../Services/Servicebanner";
import NumberInfo from "../../Home/NumberInfo";
import Doctorbox from "../../Home/Docterbox";
import Divser from "../../About/Divser";
import Divider from "../../Divider";
import ServiceReview from "../../Services/ServiceReview";
import Ultrascound from "./Ultrascound";
import { movetop } from "../../../fun";
import { Helmet } from "react-helmet-async";

function Ultrascoundcon() {
  useEffect(() => {
    movetop();
  }, []);
  type elem = {
    oneBody?: JSX.Element;
    twoBody?: JSX.Element;
    threeBody?: JSX.Element;
  };
  const elemnt: elem = {
    oneBody: <Ultrascound />,
    twoBody: <Infiry />,
    threeBody: <Callin />,
  };
  return (
    <>
      <Helmet>
        <title>Best Ultrasound in Vijayanagar</title>
        <meta
          name="description"
          content="We provide the best ultrasound in Vijayanagar and Whitefield. If you are looking for this then feel free to contact us today."
        />
        <meta
          name="keywords"
          content="Best Ultrasound in Whitefield, Best Ultrasound in Vijayanagar, healthcare services in Whitefield, healthcare services in Vijayanagar, Multispeciality Clinic in Vijayanagar"
        />

        {/* JSON-LD Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "MedicalBusiness",
            "@id":
              "https://www.elvhealthcare.com/bestultrascoundservicesinwhitefield#organization",
            name: "ELV Health Care Polyclinics",
            url: "https://www.elvhealthcare.com/bestultrascoundservicesinwhitefield",
            description:
              "ELV Health Care Polyclinics in Whitefield offers professional ultrasound services for accurate imaging and diagnosis including obstetric, abdominal, pelvic and musculoskeletal ultrasounds by experienced technicians and radiologists.",
            logo: "https://www.elvhealthcare.com/favicon.ico",
            telephone: "+91-9535264855",
            email: "elvhealthcare@gmail.com",
            address: {
              "@type": "PostalAddress",
              streetAddress: "MR ASTER, Ground Floor, Vijayanagar, Whitefield",
              addressLocality: "Bengaluru",
              addressRegion: "Karnataka",
              postalCode: "560066",
              addressCountry: "IN",
            },
            geo: {
              "@type": "GeoCoordinates",
              latitude: 12.9764418,
              longitude: 77.7583566,
            },
            hasMap: "https://maps.app.goo.gl/C1xXW4kQyTxR8Sug9",
            knowsAbout: [
              "Ultrasound imaging services",
              "Obstetric and prenatal ultrasound scans",
              "Abdominal and pelvic ultrasounds",
              "Musculoskeletal ultrasound imaging",
              "Diagnostic support for clinical evaluation",
              "Ultrasound for gynecological assessments",
              "Real-time imaging by experienced technicians",
            ],
            keywords: [
              "best ultrascound services in Immadihalli",
              "best ultrascound services in Whitefield",
              "best ultrascound services in Bangalore",
              "best ultrascound services in Kundalahalli",
              "best ultrascound services in Pattandur Agrahara",
            ],
          })}
        </script>
      </Helmet>

      <h2 style={{ display: "none" }}>
        Best Ultrasound in Vijayanagar services that contribute to the overall
        well-being of our patients. Contact us for the best ultrasound in
        Vijayanagar.
      </h2>

      <Servicebanner name="Ultrascound" banner={"../photo/dd24.jpg"} />
      <NumberInfo test="test-black" />
      <Doctorbox />
      <Divser elemnt={elemnt} />
      {/* <div className="pt-6">
                <Divider />
              </div>
              <Doctorbox /> */}
      <div className="pt-10 pb-4">
        <Divider />
      </div>
      <ServiceReview />
    </>
  );
}

export default Ultrascoundcon;
